"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabPanel = exports.Tab = exports.TabList = exports.TabContext = void 0;
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var breakpoints_1 = require("../../utils/breakpoints");
var asg_1 = require("@alinta-digital/asg");
/**
 * A Tab collection. Styles only supports 2 tabs currently.
 * Tab components require css color vars to be set before use
 *
 * Example Usage:
  ```
  function ExampleTabs(): JSX.Element {
    const [index, setIndex] = useState<number>(0);
    const handleChange = (newIndex: number) => {
      setIndex(newIndex);
    };
    return (
      <TabContext>
        <TabList>
          <Tab onClick={() => handleChange(0)} active={index === 0}>
            Tab 1
          </Tab>
          <Tab onClick={() => handleChange(1)} active={index === 1}>
            Tab 2
          </Tab>
        </TabList>
        <TabPanel active={index === 0}>Panel A</TabPanel>
        <TabPanel active={index === 1}>Panel B</TabPanel>
      </TabContext>
    );
  }
  ```
 */
exports.TabContext = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"
    /** Tab list to contain tabs */
])));
/** Tab list to contain tabs */
exports.TabList = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  border: 1px solid ", ";\n  border-radius: 12px;\n  margin: 1px;\n"], ["\n  display: flex;\n  border: 1px solid ", ";\n  border-radius: 12px;\n  margin: 1px;\n"])), asg_1.colors['grey-6']);
/** Tab Button */
exports.Tab = styled_components_1.default.button.attrs(function (props) { return ({
    type: 'button',
    className: (props.active ? 'active ' : '') + props.className,
}); })(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  cursor: pointer;\n  background-color: ", ";\n  color: ", ";\n  border: none;\n  height: 48px;\n  font-style: normal;\n  font-size: 16px;\n  width: 135px;\n  transition: filter 0.2s ease, color 0.1s ease;\n  align-self: flex-start;\n  // set slightly less radius than the tab list to account for the 1px margin\n  border-radius: 10px;\n  margin: 1px;\n  font-weight: 400;\n\n  @media (min-width: ", ") {\n    min-width: 128px;\n  }\n\n  &:hover {\n    filter: brightness(0.98);\n  }\n\n  &.active {\n    color: ", ";\n    outline: 2px solid ", ";\n  }\n"], ["\n  cursor: pointer;\n  background-color: ", ";\n  color: ", ";\n  border: none;\n  height: 48px;\n  font-style: normal;\n  font-size: 16px;\n  width: 135px;\n  transition: filter 0.2s ease, color 0.1s ease;\n  align-self: flex-start;\n  // set slightly less radius than the tab list to account for the 1px margin\n  border-radius: 10px;\n  margin: 1px;\n  font-weight: 400;\n\n  @media (min-width: ", ") {\n    min-width: 128px;\n  }\n\n  &:hover {\n    filter: brightness(0.98);\n  }\n\n  &.active {\n    color: ", ";\n    outline: 2px solid ", ";\n  }\n"])), asg_1.colors['white'], asg_1.colors.text['light'], breakpoints_1.breakpoints.sm, asg_1.colors['colour-secondary'], asg_1.colors['colour-secondary']);
/** Div that hides when not active */
exports.TabPanel = styled_components_1.default.div.attrs(function (props) { return ({
    className: (props.active ? 'active ' : '') + props.className,
}); })(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  &:not(.active) {\n    display: none;\n  }\n"], ["\n  &:not(.active) {\n    display: none;\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Tab.js.map